import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const EmployerLinkListMobile = ({handlePageChange, currentPage, nextPage, prevPage, count, data, screenWidth }) => {
  
const { t } = useTranslation();
  
  const handleCopy = (url) => {
    navigator.clipboard.writeText(url);
    alert("Link copied to clipboard!");
  };

  return (
    <>
      {data.length > 0 ? (
        data.map((item, index) => {
          const url = `https://crm.kflow.cloud/employer-biodata-shared?token=${item.token}`;
          return (
            <div key={index} className="rounded text-secondary mb-3 text-dark">
              <div className="w-100 p-3 rounded-top" style={{ backgroundColor: "#DAF8FD" }}>
                <h5 className="text-dark fw-bolder mb-2">Link { index + 1}</h5>
              </div>
              <div className="bg-white p-3 rounded-bottom">
                <div className="row mb-2">
                  <div className="col-3" style={{ paddingRight: 5 }}>
                    <p style={{ fontSize: "0.7rem" }}>URL</p>
                  </div>
                  <div className="col-1 text-center">
                    <p style={{ fontSize: "0.7rem" }}>:</p>
                  </div>
                  <div className="col-7">
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      style={{ fontSize: "0.7rem", wordBreak: "break-all" }}
                      onClick={() => handleCopy(url)}
                      title="Tap to copy"
                    >
                      https://crm.kflow.cloud/e...
                    </button>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-3" style={{ paddingRight: 5 }}>
                    <p style={{ fontSize: "0.7rem" }}>{t("Biodata")}</p>
                  </div>
                  <div className="col-1 text-center">
                    <p style={{ fontSize: "0.7rem" }}>:</p>
                  </div>
                  <div className="col-7">
                    <div>
                        {item.biodata_info && item.biodata_info.length > 0
                          ? item.biodata_info.map((itemInfo, idx) => (
                              <Link
                                key={idx}
                                className={`badge ${itemInfo.is_shortlisted ? 'bg-blue-light' : 'bg-info'} text-dark me-1 mb-1`}
                                style={{ fontSize: "0.7em" }}
                                to={{ 
                                  pathname: `/biodata/${itemInfo.id}`,
                                  state: { profile: itemInfo.details }  // Pass the biodata info as state
                                }}
                              >
                                {itemInfo.name}
                              </Link>
                            ))
                          : <span className="text-muted">-</span>
                        }
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3" style={{ paddingRight: 5 }}>
                    <p style={{ fontSize: "0.7rem" }}>{t("Created By")}</p>
                  </div>
                  <div className="col-1 text-center">
                    <p style={{ fontSize: "0.7rem" }}>:</p>
                  </div>
                  <div className="col-7">
                    <p style={{ fontSize: "0.7rem" }} className="fw-bold">{item.created_by}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3" style={{ paddingRight: 5 }}>
                    <p style={{ fontSize: "0.7rem" }}>{t("Created Date")}</p>
                  </div>
                  <div className="col-1 text-center">
                    <p style={{ fontSize: "0.7rem" }}>:</p>
                  </div>
                  <div className="col-7">
                    <p style={{ fontSize: "0.7rem" }} className="fw-bold">{item.created_at}</p>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="p-3 rounded bg-white text-secondary mb-3">
          <p>No Data</p>
        </div>
      )}

      {/* Pagination Controls */}
      <div className="mt-3">
        <button
          className="btn btn-secondary me-2"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {t("Previous")}
        </button>
        <span>{t("Page")} {currentPage} {t("of")} {Math.ceil(count / 10)}</span>
        <button
          className="btn btn-secondary ms-2"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          {t("Next")}
        </button>
      </div>
    </>
  );
};

EmployerLinkListMobile.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  screenWidth: PropTypes.number.isRequired,

  handlePageChange: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  nextPage: PropTypes.func.isRequired,
  prevPage: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
};

export default EmployerLinkListMobile;